var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #717402;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "video",
    transform: "translate(-266 733)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    className: "cls-1",
    width: 200,
    height: 200,
    transform: "translate(266 -733)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-video",
    "data-name": "Icon feather-video",
    transform: "translate(274.5 -690.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    className: "cls-2",
    d: "M81.986,2a7.834,7.834,0,0,1,7.833,7.834V93.621A7.834,7.834,0,0,1,77.432,100L18.781,58.1a7.834,7.834,0,0,1,0-12.75L77.432,3.459A7.83,7.83,0,0,1,81.986,2ZM74.151,78.4V25.057L36.812,51.728Z",
    transform: "translate(101.681 6.257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    className: "cls-2",
    d: "M17.592-1h92.166a24.619,24.619,0,0,1,24.592,24.592v83.787a24.619,24.619,0,0,1-24.592,24.592H17.592A24.619,24.619,0,0,1-7,107.379V23.592A24.619,24.619,0,0,1,17.592-1Zm92.166,117.3a8.933,8.933,0,0,0,8.923-8.923V23.592a8.933,8.933,0,0,0-8.923-8.923H17.592a8.933,8.933,0,0,0-8.923,8.923v83.787a8.933,8.933,0,0,0,8.923,8.923Z",
    transform: "translate(-1.5 -7.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.9a8b70034947cb5fe721b6125654ef82.svg";
export { ForwardRef as ReactComponent };